import { getMap } from '../_flux/helper/gmap';
import { showAction as lbLockUi, hideAction as lbUnlockUi, loadingDoneAction } from '../_flux/actions/lightbox_ui_lock_actions';
import { getValue, setValue } from '../utilities/local_storage';

const window = require('window');

window.TYROOLA = window.TYROOLA || {};

// jQuery Deferred that resolves on google maps initialization
window.TYROOLA.mapsInitiated = $.Deferred();

/**
 * load google-maps
 */
export function loadGoogleMapDependencies(hideLightbox) {
    const { hasMaps, apiKey } = TYROOLA.globals.googleMapsData;
    if (hasMaps && !getMap()) {
        if (location.href.indexOf('/checkout/') === -1 && !hideLightbox) {
            lbLockUi();
        }
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?libraries=places,geometry,marker&key=${apiKey}&loading=async&callback=initGoogleMapDependencies`;
        script.async = true;
        script.onerror = () => {
            if (location.href.indexOf('/checkout/') === -1 && !hideLightbox) {
                loadingDoneAction();
            }
        };
        
        document.head.appendChild(script);
    }
}

/**
 * Initialise some handling once google-maps is loaded
*/
function initGoogleMapDependencies() {
    "use strict";
    
    window.TYROOLA.mapsInitiated.resolve();
}
window.initGoogleMapDependencies = initGoogleMapDependencies;
if (location.href.indexOf('fitting=1') !== -1 || location.href.indexOf('tyre-shops') !== -1) {
    loadGoogleMapDependencies();
}

export default initGoogleMapDependencies;
